import React, { useMemo, useState } from "react";
import makidoctor from "../../assets/cards/maki_doctor.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DropdownMenu from "../modals/menu";
import Paymentsmodal from "../modals/payments";
import AssignRoomModal from "../modals/assignroommodal";
import VisitStatusModal from "../modals/visitstatusmodal";
import PurposeOfVisitModal from "../modals/purposeofvisitmodal";
import ProviderModal from "../modals/Providermodal";
import AddNotesModal from "../modals/notemodal";
import FlagModal from "../modals/flagmodal";
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import {
  actionDropDownCalenderIcon,
  actionDropDownChatIconBig,
  actionDropDownSchedulerIconBig,
  filterIcon,
  intakeiconbig,
  RoomBadge,
  vitalsiconbig,
} from "../modals/svgs";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  alertIcon,
  ChartIcon,
  COMPLETEDIcon,
  CROSSIcon,
  listFileIcon,
  NotesIcon,
  OrderIcon,
  actionDropDownCalenderIconbig,
  actionDollarIconbig,
} from "../modals/svgs";
import TasksModal from "../../tasks/Modals/TasksModal";
import { pendingIcon } from "../../orders/tabs/svg";
import { eventBus } from "../../utils/eventBus";

const statusChipClasses = (label, active) => {
  if (!active) return "border-[#ECECEE] text-[#1D4ED8]";
  if (label === "Ready for Triage") return "border-[#A7F3D0] text-[#065F46]";
  if (label === "Cancelled") return "border-[#FECACA] text-[#991B1B]";
  if (label === "In-Office - Confirmed")
    return "border-[#E9D5FF] text-[#581C87]";
  if (label === "Ready for Representative")
    return "border-[#FEF08A] text-[#854D0E]";
  if (label === "Processing") return "border-[#E2E8F0] text-[#1E293B]";
  if (label === "Walk-in") return "border-[#DDD6FE] text-[#4C1D95]";
  if (["Injections", "Labs"].includes(label))
    return "border-[#FED7AA] text-[#9A3412]";
  if (label === "Checked Out") return "border-[#FDA4AF] text-[#9F1239]";
  if (label === "Ready for Provider") return "border-[#FBCFE8] text-[#9D174D]";
  if (label === "Ready for Checkout") return "border-[#C7D2FE] text-[#312E81]";
  if (label === "Ready for Nurse") return "border-[#A5F3FC] text-[#155E75]";
  if (label === "No Show") return "border-[#D1D5DB] text-[#1F2937]";
  if (label === "Active") return "border-[#BBF7D0] text-[#166534]";
  if (label === "Rescheduled") return "border-[#BFDBFE] text-[#1E40AF]";
  return "border-[#A2F4FD66] text-[#00786F]";
};

const CardView = ({
  setFetchedData,
  setSelectedCard,
       searchTerm,
   handleschedular,
  modalopen,
  insertdata,
  alldata,
  data,
  dob,
  setChat,
  fetchpcarddata,
  markAsComplete,
  markAscancel,
  onUpdateVisitStatus,
  onUpdateRoom,
  refreshDashboard,
  paymentdetails,
  setSelectedOrder,
  handleconfirmScheduleClick,
  scheduleStates,
  setToastSeverity,
  setToastMessage,
  setOpenToast,
}) => {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [visitModalOpen, setVisitModalOpen] = useState(false);
  const [roomModalOpen, setRoomModalOpen] = useState(false);
  const [ordersExpanded, setOrdersExpanded] = useState(false);
  const [isQuickOpen, setIsQuickOpen] = useState(false);
  const [totalOrders, setTotalOrders] = useState([]);
const [showMore, setShowMore] = useState(false);
const location =useLocation()
    const fromPatientId = location.state?.fromPatientId;
  const homescreenprev = useSelector(
    (state) => state.userPrivileges.homescreen
  );
  const [purposeModalOpen, setPurposeModalOpen] = useState(false);
  const [providerModalOpen, setProviderModalOpen] = useState(false);
  const [localProvider, setLocalProvider] = useState(
    data.linked_provider || ""
  );
  const userConfig = useSelector((state) => state.userconfig);
  const taskscreenprev = useSelector((state) => state.userPrivileges.taskrpm);
  const [isFlagOpen, setIsFlagOpen] = useState(false);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [noteDraft, setNoteDraft] = useState({
    assignee: "Provider",
    message: "",
  });

  const navigate = useNavigate();
  const reduxDate = useSelector((state) => state.filter.currentDate);

  // const startDateObj = new Date(data.startdate);
  // const formattedDate = useMemo(() => {
  //   const y = startDateObj.getFullYear();
  //   const m = String(startDateObj.getMonth() + 1).padStart(2, "0");
  //   const d = String(startDateObj.getDate()).padStart(2, "0");
  //   return `${y}-${m}-${d}`;
  // }, [data.startdate]);
  // const isSameDate = formattedDate === reduxDate;
const startDateObj = dayjs(data.startdate, "YYYY-MM-DD HH:mm:ss");

// redux date (assume format YYYY-MM-DD)
const dtObj = dayjs(reduxDate, "YYYY-MM-DD");
const isSameDate = startDateObj.isSame(dtObj, "day");
  const openPaymentModal = () => setIsPaymentModalOpen(true);
  const closePaymentModal = () => setIsPaymentModalOpen(false);
  const openNoteModal = () => setNoteModalOpen(true);
  const closeNoteModal = () => setNoteModalOpen(false);

  // -------- Orders / Tasks UI helpers (style-only; reads data from `data`) --------
  const orders = Array.isArray(data?.orders) ? data.orders : [];
  const paymentdetailsArray = Array.isArray(paymentdetails)
    ? paymentdetails
    : [];

  const handleScheduleClick = (order) => {
    setSelectedOrder(order); // Set the selected order for confirmation
  };

  // const listedCount = orders.reduce((acc, order) => {
  //   const rawType = (order?.ordertype || "").trim();
  //   const isVisit = rawType.toUpperCase() === "VISIT";
  //   if (!isVisit) return acc + 1;
  //   let c = 0;
  //   if (order?.tov) c += 1;
  //   if (order?.tov2) c += 1;
  //   return acc + c;
  // }, 0);

  const completedOrCancelled = ["COMPLETED", "CANCELLEDTASK"];

  const allInactive =
    orders.length > 0 &&
    orders.every((order) =>
      completedOrCancelled.includes(String(order?.status).toUpperCase())
    );

  // Count active orders only (non-completed/cancelled)
  const activeOrders = orders.filter(
    (order) =>
      !completedOrCancelled.includes(String(order?.status).toUpperCase())
  );

  const activeCount = activeOrders.reduce((acc, order) => {
    const rawType = (order?.ordertype || "").trim();
    const isVisit = rawType.toUpperCase() === "VISIT";
    if (!isVisit) return acc + 1;
    let c = 0;
    if (order?.tov) c += 1;
    if (order?.tov2) c += 1;
    return acc + c;
  }, 0);

  // Count all (for when all are inactive)
  const totalCount = orders.reduce((acc, order) => {
    const rawType = (order?.ordertype || "").trim();
    const isVisit = rawType.toUpperCase() === "VISIT";
    if (!isVisit) return acc + 1;
    let c = 0;
    if (order?.tov) c += 1;
    if (order?.tov2) c += 1;
    return acc + c;
  }, 0);

  // Decide what to show
  const listedCount = allInactive ? totalCount : activeCount;

  const renderOrderRow = (order, label, value, key) => {
    const status = String(order?.status || "").toUpperCase();
    const isCompleted = status === "COMPLETED";
    const isCancelled = status === "CANCELLEDTASK";

    const matchedPatient = paymentdetailsArray.find(
      (p) => p.content === order?.ordername
    );

    return (
      <div
        key={key}
        className={`flex w-full items-center justify-between py-3 border-b border-gray-100 ${
          (isCompleted || isCancelled) && userConfig?.config?.tasks_completed
            ? "opacity-60"
            : ""
        }`}
      >
        {/* Left Section: Label */}
        <div className="flex items-center min-w-[100px]">
        <div className="mr-2 flex items-center">
  {isCompleted ? (
    <span className="text-green-500">{COMPLETEDIcon}</span>
  ) : isCancelled ? (
    <span className="text-red-500">{CROSSIcon}</span>
  ) : (
    pendingIcon
  )}
</div>

          <span
            className={`uppercase font-inter text-xs font-normal ${
              (isCompleted || isCancelled) &&
              userConfig?.config?.tasks_completed
                ? "text-[#98A2B3]"
                : "text-[#6B7280]"
            }`}
          >
            {label}
          </span>
        </div>

        {/* Middle Section: Value */}
        <div
          className={`flex-1 text-sm font-medium font-inter text-center truncate ${
            (isCompleted || isCancelled) && userConfig?.config?.tasks_completed
              ? "text-[#98A2B3]"
              : "text-[#000000]"
          }`}
        >
          {value || "-"}
        </div>

        {/* Right Section: Price */}
        {!!matchedPatient && userConfig?.config?.show_prices && (
          <div
            className={`text-right font-inter font-bold text-[16px] ${
              isCompleted || isCancelled ? "text-[#98A2B3]" : "text-[#F97316]"
            }`}
          >
            ${matchedPatient.insurance_cost}
          </div>
        )}
      </div>
    );
  };

  // clean insurance text (no trailing space, ellipsis only if needed)
  const insuranceClean = ((data.insurancename ?? "-") + "").trim();
  const insuranceShort =
    insuranceClean.length > 14
      ? `${insuranceClean.slice(0, 14)}…`
      : insuranceClean;
  const allActions = [
    {
      id: 1,
      key: "Chart",
      icon: ChartIcon,
      label: "Charts",
      onClick: () => modalopen(data.id),
      visible: homescreenprev.includes("Chart"),
    },
    {
      id: 2,
      key: "Order",
      icon: OrderIcon,
      label: "Orders",
      onClick: () =>{
        if(!isSameDate){
setToastMessage('Please schedule an appointment')
setToastSeverity('info')
setOpenToast(true)
return
}
        navigate(`/orders/${data.appointmentid}/${data.startdate}/${(searchTerm||fromPatientId)?'filter':"all"}`)},
      visible: homescreenprev.includes("Order"),
    },
    {
      id: 3,
      key: "Notes",
      icon: NotesIcon,
      label: "Notes",
      onClick: openNoteModal,
      visible: homescreenprev.includes("Notes"),
    },
    {
      id: 4,
      key: "Take Payment",
      icon: actionDollarIconbig,
      label: "Payments",
      onClick: openPaymentModal,
      visible: homescreenprev.includes("Take Payment"),
    },
    {
      id: 5,
      key: "Imaging",
      icon: actionDropDownCalenderIconbig,
      label: "Imaging",
      onClick: () => insertdata(data),
      visible: true,
    },
    {
      id: 6,
      key: "Chat",
      icon: actionDropDownChatIconBig,
      label: "Chat",
      onClick: () => {
        setSelectedCard(data);
        setChat(true);
      },
      visible: true,
    },
    {
      id: 7,
      key: "Scheduler",
      icon: actionDropDownSchedulerIconBig,
      label: "Scheduler",
    onClick: () => {
        setSelectedCard(data);
      handleschedular(data)
      },
      visible: true,
    },
         {
          id: 8,
          key: "Vitals",
          icon: vitalsiconbig,
          label: "Vitals",
        onClick: () => {
      modalopen(data.id);
    
      setTimeout(() => {
        eventBus.emit("navigateToPriorVitals", { tab: 3 });
      }, 50); // or 100ms if needed
    } ,
          visible: homescreenprev.includes("Chart"),
        },
        {
              id: 9,
              key: "Intake",
              icon: intakeiconbig,
              label: "Intake",
            onClick: () => {
          modalopen(data.id);
        
          setTimeout(() => {
            eventBus.emit("navigateToPriorVitals", { tab: 3 ,internalTab:0});
          }, 50); // or 100ms if needed
        } ,
              visible: homescreenprev.includes("Chart"),
            }
  ];
   const formatTime = (time) => {
    if (!time) return "-";

    const [hourStr, minute] = time.split(":");
    let hour = Number(hourStr);

    const period = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // convert 0 → 12

    return `${hour}:${minute} ${period}`;
  };
  const latestAppointment = (() => {
    if (!Array.isArray(data?.allappts)) return null;

    const grouped = {};

    data.allappts.forEach((appt) => {
      const date = dayjs(appt.startdate).format("YYYY-MM-DD");

      if (!grouped[date]) grouped[date] = [];
      grouped[date].push(appt);
    });

    const result = Object.values(grouped).map((appointments) => {
      const valid = appointments.filter(
        (a) => a.visit_confirmation !== "Cancelled",
      );

      const list = valid.length ? valid : appointments;

      return list.sort(
        (a, b) => new Date(b.startdate) - new Date(a.startdate),
      )[0];
    });

    return result[0] || null; // 👈 THIS LINE
  })();
  // Get pinned actions based on user config
  const pinnedActions =
    Array.isArray(userConfig?.config?.dash_pins) &&
    userConfig.config.dash_pins.length > 0
      ? userConfig.config.dash_pins
          .map((id) => allActions.find((act) => act.id === id))
          .filter(Boolean)
          .slice(0, 3)
          .reverse()
      : allActions.slice(0, 3);

  return (
       <div className={`
    relative bg-white max-w-[385px] rounded-2xl shadow-lg
    border-[1.3px]  flex flex-col
    ${  latestAppointment?.visit_confirmation === "Cancelled" ? "border-[#E6444C]  " : data?.quality_risk_metrics ? "border-[#800080]" : "border-gray-200"}
  `} >

{
  latestAppointment?.visit_confirmation === "Cancelled" ? (
    <div className="w-full bg-[#E6444C] text-white text-[12px] font-inter font-medium py-1 text-center rounded-t-[10px]">
      CANCELLED
    </div>
  ) : data?.quality_risk_metrics ? (
    <div className="w-full bg-[#800080] text-white text-[12px] font-inter font-medium py-1 text-center rounded-t-[10px]">
      Risk Adjustments and Quality Measure - Eligible
    </div>
  ) : null
}
 {  latestAppointment?.visit_confirmation === "Cancelled"?<></>: <div
    onClick={() => {
      if (homescreenprev.includes("Room Assignment")) {
        setRoomModalOpen(true);
      }
    }}
    className={`absolute ${data?.visit_confirmation === "Cancelled"?'top-6':"top-0"} left-[85%] z-10 cursor-pointer`}
  >
    <RoomBadge roomNo={data?.room_no}width={32} height={41} />
  </div>}
    <div className=" w-full  p-3 flex flex-col self-start">
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-3">
          <div className="flex flex-col items-center justify-center w-[90px]">
            <div
              onClick={() => {
                if (homescreenprev.includes("P-Card")) fetchpcarddata(data.id);
              }}
              className="relative w-[66px] h-[66px] rounded-[14px] border-2 overflow-hidden cursor-pointer"
                style={{ border: `${3.5}px solid #${data.deductiblemet}` }}
              title="Open P-Card"
            >
              <img
                src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
                alt="profile"
                className="w-full h-full object-cover"
                onError={(e) =>
                  (e.target.src =
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
                }
              />
            </div>

            {data?.purpose && (
              <button
                onClick={() => setPurposeModalOpen(true)}
                title="Update Purpose of Visit"
                className="mt-2 bg-[#D1E1FF] border-[1px] border-[#00000000] px-1.5 py-[2px] rounded-[10px] text-[#004867] font-inter text-[12px] font-medium focus:outline-none cursor-pointer"
              >
                {data.purpose}
              </button>
            )}
          </div>

          {/* Name / IDs / DOB */}
          <div className="flex flex-col items-start justify-start">
            <div className="flex items-start gap-2">
              <div className="text-[#1F2937] font-inter font-medium text-[16px] leading-5">
                {`${data.firstname} ${data.lastname}`}
              </div>
            </div>

            <div className="flex items-start gap-2 mt-1 text-xs">
              <span className="text-[#6B7280] font-inter">
                #{data.patientid || "-"}
              </span>
            </div>
            <div className="flex items-start gap-2 mt-1 text-xs">
              <span className="text-[#6B7280] font-inter">
                {insuranceShort}
              </span>
            </div>

            <div className="mt-1 text-xs font-font1 text-[#4A5565] self-start">
              DOB:{" "}
              {dayjs((dob || data.dob)?.trim()).format("MMM D, YYYY") || "-"}
            </div>
            {isSameDate ? (
              <></>
            ) : (
              <span className="text-xs flex justify-center items-center gap-1  font-font1 mt-2 text-[#4A5565]">
                {actionDropDownCalenderIcon}
                {dayjs(data?.startdate).format("MM-DD-YYYY")}
              </span>
            )}
          </div>
        </div>

        {/* Right: room */}
        {/* <div className="flex flex-col items-end">
          {data.room_no ? 
            <button
  className={`bg-[#E17954] text-white rounded-[4px] font-inter font-medium ${
    data.room_no === "Waiting Room" ? "text-sm" : "text-lg"
  } ${
    homescreenprev.includes("Room Assignment")
      ? "cursor-pointer"
      : "cursor-not-allowed opacity-70"
  } focus:outline-none px-[6px] py-[4px] flex items-center gap-[4px]`}
  title={homescreenprev.includes("Room Assignment") ? "Assign Room" : ""}
  onClick={() => {
    if (homescreenprev.includes("Room Assignment"))
      setRoomModalOpen(true);
  }}
>
  {data.room_no !== "Waiting Room" && (
    <MeetingRoomOutlinedIcon fontSize="small" />
  )}
  <span>{data.room_no || "Waiting Room"}</span>
</button>
:
         <div   onClick={() => {
                    if (homescreenprev.includes("Room Assignment")) {
                      setRoomModalOpen(true);
                    }
                  }}    className="w-10 h-10 bg-[#E17954B2] cursor-pointer p-[12px] font-inter text-white rounded-full flex items-center justify-center text-[12px]">
                -
                
                </div> }
        </div> */}
      </div>

      {/* Provider + time */}
      <div className="flex items-center justify-between mt-3">
        <button
          onClick={() => {
  if (homescreenprev.includes("Change Provider")) {
                  setProviderModalOpen(true);
                }

          }}
          className="flex items-center"
          title="Update Provider"
        >
          <img src={makidoctor} alt="Doctor Icon" className="w-3 h-3 mr-1" />
          <span className="text-[#1D2951] font-inter text-sm">
            {latestAppointment?.linked_provider || "-"}
          </span>
        </button>

        <div className="bg-[#0F172B] border-[1px] border-[#00000000] px-1.5 py-[2px] rounded-[10px] text-[#FFFFFF] font-inter text-[12px] font-medium">
         {formatTime(latestAppointment?.starttime) || "-"}
        </div>
        {latestAppointment?.visit_confirmation ? (
          <button
            onClick={() => {
              if (homescreenprev.includes("Visit Confirmation")) {
                setVisitModalOpen(true);
              }
            }}
            className={
              "px-2.5 py-[2px] font-inter font-medium rounded-[10px] text-[12px] border-[1px] focus:outline-none " +
              statusChipClasses(
              latestAppointment?.visit_confirmation,
                Boolean(data.visit_confirmation)
              )
            }
            title="Update Visit Status"
          >
            {latestAppointment?.visit_confirmation}
          </button>
        ) : (
          <button
            className={
              "px-2.5 py-[2px] font-inter font-medium rounded-[10px] text-[12px] border-[1px] focus:outline-none " +
              statusChipClasses(
               latestAppointment?.visit_confirmation,
                Boolean(latestAppointment?.visit_confirmation)
              )
            }
            title="Update Visit Status"
          >
            Visit Status
          </button>
        )}
      </div>

      {/* Notes/Tests Due placement handled below */}

      {/* Orders / Tasks */}
      <div className="mt-4">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <span className="text-[#6B7280] font-[600] font-inter text-[14px]">
              Orders / Tasks
            </span>
            <span
              className={`inline-flex items-center justify-center h-6 w-6 rounded-full text-[12px] font-semibold ${
                allInactive
                  ? "bg-[#E5E7EB] text-[#6B7280]"
                  : listedCount > 0
                  ? "bg-[#DF6F46] text-white"
                  : "bg-[#E5E7EB] text-[#6B7280]"
              }`}
            >
              {listedCount}
            </span>
          </div>
          <button
            onClick={() => setOrdersExpanded((v) => !v)}
            aria-label="Toggle orders "
            className="p-1 text-[#6B7280] focus:outline-none"
            title={ordersExpanded ? "Collapse" : "Expand"}
          >
            {/* chevron */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              className={`${
                ordersExpanded ? "rotate-180" : "rotate-0"
              } transition-transform`}
            >
              <path
                d="M6 9l6 6 6-6"
                stroke="#6B7280"
                strokeWidth="2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        {ordersExpanded && (
          <button
            className="h-[210px] w-full overflow-y-auto custom-scrollbar pr-1 focus:outline-none flex flex-col justify-start items-start text-left"
            onClick={() => {
              if (!orders.length) return;
              setTotalOrders(orders);
              setIsQuickOpen(true);
            }}
          >
            {orders.length === 0 ? (
              <div className="flex w-full flex-col justify-center items-center h-full text-center py-8">
                <div className="mb-3">{listFileIcon}</div>

                <p className="text-[#6B7280] text-sm font-medium font-inter mb-1">
                  No orders yet
                </p>

                <p className="text-[#9CA3AF] text-xs font-normal font-inter">
                  Orders will appear here when added
                </p>
              </div>
            ) : (
              <div className="flex flex-col justify-between items-start w-full">
                {[...orders]
                  .sort((a, b) => {
                    const getOrderRank = (status) => {
                      const s = String(status).toUpperCase();
                      if (s === "COMPLETED") return 2; // middle
                      if (s === "PENDING" || s === "CANCELLEDTASK") return 3; // last
                      return 1; // normal first
                    };
                    return getOrderRank(a.status) - getOrderRank(b.status);
                  })
                  .map((order) => {
                    const rawType = (order?.ordertype || "").trim();
                    const isVisit = rawType.toUpperCase() === "VISIT";
                    const isNotes = rawType.toLowerCase() === "notes";
                    const typeLabel =
                      rawType.charAt(0).toUpperCase() +
                      rawType.slice(1).toLowerCase();

                    const name = order?.ordername || "-";
                    const MAX_CHARS = 35;
                    const clipped =
                      name.length > MAX_CHARS
                        ? `${name.slice(0, MAX_CHARS)}…`
                        : name;

                    if (!isVisit) {
                      return renderOrderRow(
                        order,
                        isNotes
                          ? `${typeLabel} ${order?.user_role || ""}`.trim()
                          : typeLabel,
                        clipped,
                        order.id
                      );
                    }

                    return (
                      <React.Fragment key={order.id}>
                        {order?.tov &&
                          renderOrderRow(
                            order,
                            "Visit",
                            order.tov,
                            `${order.id}-tov`
                          )}
                        {order?.tov2 &&
                          renderOrderRow(
                            order,
                            "Visit",
                            order.tov2,
                            `${order.id}-tov2`
                          )}
                      </React.Fragment>
                    );
                  })}
              </div>
            )}
          </button>
        )}
      </div>
      {/* {ordersExpanded && ( */}
   {data?.notes?.trim()?<div className="flex flex-col gap-1 w-full">
  <div className="bg-[#F9FAFB] rounded-md p-2.5 relative">
    <span className="font-[400] ml-1 w-full flex font-inter text-xs text-[#62748E] mb-2">
      Notes
    </span>

    <div className="flex text-left items-start gap-1">
      <div className="pt-[2px]">{alertIcon}</div>

      <span className="text-sm font-inter font-normal text-[#BB4D00]">
        {(() => {
          let cleaned = data.notes
            ?.replace(/<br\s*\/?>/gi, "")
            .trim() || "";

          let formatted =
            cleaned.charAt(0).toUpperCase() + cleaned.slice(1);

          // Prefix Notes:
          if (formatted.match(/^Test\(s\) Due:/i)) {
            formatted = formatted.replace(/^Test\(s\) Due:/i, "Notes:");
          } else {
            formatted = `Notes: ${formatted}`;
          }

          // Truncate if not showing more
          if (!showMore && formatted.length > 80) {
            return formatted.slice(0, 80) + "...";
          }

          return formatted;
        })()}
      </span>
    </div>

    {/* Show more / Show less */}
    {data.notes && data.notes.length > 80 && (
      <button
        onClick={() => setShowMore(!showMore)}
        className="absolute bottom-1 right-2 text-[12px] font-inter"
        style={{ color: "#50869A" }}
      >
        {showMore ? "Show less" : "Show more"}
      </button>
    )}
  </div>
</div>:<div className="flex flex-col  gap-1 w-full">
  
  </div>}

      {/* )} */}

      {/* Bottom actions */}
      <div className="flex items-center justify-between mt-4 px-3 pt-2 border-t">
        {pinnedActions.map((action) => (
          <div key={action.id} className="relative group">
            <button
              onClick={action.onClick}
              className={`${
                (action.key === "Notes" && noteModalOpen) ||
                (action.key === "Take Payment" && isPaymentModalOpen)
                  ? "bg-[#1D2951] text-white"
                  : "bg-[#F9FAFB]"
              } h-[56px] w-[56px] flex justify-center items-center rounded-[12px] cursor-pointer hover:bg-[#1D2951] hover:text-white transition`}
            >
              {action.icon}
            </button>
            <span className="absolute top-[60px] left-1/2 -translate-x-1/2 bg-[#1D2951] text-white text-xs font-medium py-1 px-2 rounded-md opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-200 whitespace-nowrap">
              {action.label}
            </span>
          </div>
        ))}

        {homescreenprev.includes("Actions") && (
          <div className="">
            <DropdownMenu
              isSameDate={isSameDate}
                 setToastSeverity={setToastSeverity}
  setToastMessage={setToastMessage}
  setOpenToast={setOpenToast}
              data={data}
              insertdata={insertdata}
              openPaymentModal={openPaymentModal}
              openNoteModal={openNoteModal}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              homescreenprev={homescreenprev}
              type={"under"}
              setSelectedCard={setSelectedCard}
              setChat={setChat}
               handleschedular={ handleschedular}
               modalopen={modalopen}
               searchTerm={searchTerm}
               loc={'card'}
            />
          </div>
        )}
      </div>

      {/* Modals (unchanged functionality) */}
      {visitModalOpen && (
        <VisitStatusModal
          open={visitModalOpen}
          current={data.visit_confirmation || ""}
          onClose={() => setVisitModalOpen(false)}
          selectedCard={data}
          setFetchedData={setFetchedData}
          setVisitModalOpen={setVisitModalOpen}
        />
      )}

      {roomModalOpen && (
        <AssignRoomModal
          setRoomModalOpen={setRoomModalOpen}
          setFetchedData={setFetchedData}
          open={roomModalOpen}
          currentRoom={data.room_no || ""}
          onClose={() => setRoomModalOpen(false)}
          selectedCard={data}
          alldata={alldata}
        />
      )}

      {purposeModalOpen && (
        <PurposeOfVisitModal
          open={purposeModalOpen}
          setFetchedData={setFetchedData}
          setPurposeModalOpen={setPurposeModalOpen}
          onClose={() => setPurposeModalOpen(false)}
          selectedCard={data}
        />
      )}

      {providerModalOpen && (
        <ProviderModal
          open={providerModalOpen}
          selectedCard={data}
          onClose={() => setProviderModalOpen(false)}
          setFetchedData={setFetchedData}
          setProviderModalOpen={setProviderModalOpen}
        />
      )}

      {noteModalOpen && (
        <AddNotesModal
          open={noteModalOpen}
          defaultAssignee={noteDraft.assignee}
          defaultMessage={noteDraft.message}
          setNoteModalOpen={setNoteModalOpen}
          setFetchedData={setFetchedData}
          selectedCard={data}
          refreshDashboard={refreshDashboard}
        />
      )}

      {isPaymentModalOpen && (
        <Paymentsmodal
       
          data={data}
          
             setFetchedData={setFetchedData}
   alldata={alldata}
        
         
fetchedData={alldata}
            
            closePaymentModal={closePaymentModal}
        />
      )}

      <FlagModal
        open={isFlagOpen}
        defaultText=""
        defaultStatus="unresolved"
        onClose={() => setIsFlagOpen(false)}
        onUpdate={({ text, status }) => {
          setIsFlagOpen(false);
        }}
      />

      {isQuickOpen && (
        <TasksModal
          setFetchedData={setFetchedData}
          setToastSeverity={setToastSeverity}
          setToastMessage={setToastMessage}
          setOpenToast={setOpenToast}
          handleconfirmScheduleClick={handleconfirmScheduleClick}
          scheduleStates={scheduleStates}
          closetaskModal={() => {
            setIsQuickOpen(false);
          }}
          handleScheduleClick={handleScheduleClick}
          task={totalOrders}
          markAsComplete={markAsComplete}
          markAscancel={markAscancel}
          data={data}
        />
      )}
    </div>
    </div>
  );
};

export default CardView;
